import * as angular from 'angular';

"use strict";

angular.module('DatetimeModule', [])

export default 'DatetimeModule';
